/**
 * Reportar bug ou melhoria: o botão do rodapé do menu. Qualquer pessoa logada reporta; quem tem
 * `feedback.report.manage` trata. O contexto (tela, navegador, tamanho da tela) vem da própria tela.
 */
import { z } from 'zod';

export const FEEDBACK_KINDS = ['bug', 'improvement'] as const;
export type FeedbackKind = (typeof FEEDBACK_KINDS)[number];

export const FEEDBACK_STATUSES = ['new', 'in_progress', 'done', 'declined'] as const;
export type FeedbackStatus = (typeof FEEDBACK_STATUSES)[number];

/** Situações em que o reporte ainda está aberto (aceita prints novos). */
export const FEEDBACK_OPEN: readonly FeedbackStatus[] = ['new', 'in_progress'];

/** Até quantos prints um reporte guarda. */
export const FEEDBACK_MAX_ATTACHMENTS = 5;

/** Só imagens viram print do reporte. */
export const FEEDBACK_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/gif', 'image/webp'] as const;

const optionalText = (max: number) =>
  z
    .string()
    .trim()
    .max(max)
    .optional()
    .nullable()
    .transform((v) => (v ? v : null));

export const feedbackReportInput = z.object({
  kind: z.enum(FEEDBACK_KINDS),
  title: z.string().trim().min(3, 'Escreva um título curto').max(150),
  description: z.string().trim().min(1, 'Conte o que aconteceu ou a ideia').max(5000),
  pagePath: z.string().trim().max(500).regex(/^\//, 'Endereço da tela inválido'),
  pageTitle: optionalText(200),
  userAgent: optionalText(500),
  screenSize: z
    .string()
    .regex(/^\d{1,5}x\d{1,5}$/)
    .optional()
    .nullable()
    .transform((v) => v ?? null),
  locale: optionalText(20),
});
export type FeedbackReportInput = z.input<typeof feedbackReportInput>;

export const feedbackHandleInput = z.object({
  status: z.enum(FEEDBACK_STATUSES),
  response: optionalText(5000),
});
export type FeedbackHandleInput = z.input<typeof feedbackHandleInput>;

/** Liga ou desliga o botão Reportar para todo mundo. */
export const feedbackSettingsInput = z.object({ buttonEnabled: z.boolean() });
export type FeedbackSettingsInput = z.input<typeof feedbackSettingsInput>;
